module.exports = __webpack_public_path__ + "static/media/loginscreen.136cd82c.png";